/*
const clientId = ' 56eceab74b054b93a9bd11594e1a1938'; // Insert API key here.
//const clientSecret ' 8e7eaf9ce81d4d8bade6c94ff50ae456';

const redirectURI = 'http://localhost:3000/'
let accessToken;
let expiresTime;
const Spotify = {
	 getAccessToken(){
    if (!accessToken) {
      let url = window.location.href;
      const accessTokenFromURL = url.match(/access_token=([^&]*)/);
      const expirationTimeFromURL = url.match(/expires_in=([^&]*)/);
       if(accessTokenFromURL && expirationTimeFromURL){
         accessToken = accessTokenFromURL[1];
         expiresIn = expirationTimeFromURL[1];
         window.setTimeout(() => accessToken = '', expiresIn * 1000);
         window.history.pushState('Access Token', null, '/');
         return accessToken;
       } else {
         const accessUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectURI}`;
         window.location = accessUrl;
    }}
   return accessToken;
 },

  search(term) {
    return fetch(`https://cors-anywhere.herokuapp.com/https://api.spotify.com/v3/businesses/search?term=${term}&location=${location}&sort_by=${sortBy}`, {
      headers: {
        Authorization: `Bearer ${newAcessToken}`
      }
    }).then(response => {
      return response.json();
    }).then(jsonResponse => {
      if (jsonResponse.tracks) {
        return jsonResponse.tracks.items.map(track => ({
          id: track.id,
          name: track.name,
          
         
          artist: track.artists[0].name,
          album: track.album.name,
          uri: track.uri
        }));
      }
    });
  }


 savePlayList(playListName, trackURIs){
    if (!playListName || !trackURIs.length) {
      return;
    }
    const newAccessToken = this.getAccessToken();
    let userId;
    let playListId;
    const header = {
       Authorization: `Bearer ${newAccessToken}`
     };




if (!PlayList || !trackUris.length) {
      return;
    }
    return fetch('https://api.spotify.com/v1/me', {headers: headers}
    ).then(response => response.json();
    ).then(jsonResponse => {
      userId = jsonResponse.id;
      return fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify({name: playList})
      }).then(response => response.json()
      ).then(jsonResponse => {
        const playlistId = jsonResponse.id;
        return fetch(`https://api.spotify.com/v1/users/${userId}/playlists/${playlistId}/tracks`, {
          headers: headers,
          method: 'POST',
          body: JSON.stringify({uris: trackUris})
        });
      });
    });
  }
};

export default Spotify;*/


const clientId = '56eceab74b054b93a9bd11594e1a1938';


//const clientSecret = ' 8e7eaf9ce81d4d8bade6c94ff50ae456';
//const redirectURI = 'http://localhost:3000';
const redirectURI = 'http://localhost:3000/';

let accessToken;
let expiresIn;

const Spotify = {
  getAccessToken(){
    if (!accessToken) {
      let url = window.location.href;
      const accessTokenFromURL = url.match(/access_token=([^&]*)/);
      const expirationTimeFromURL = url.match(/expires_in=([^&]*)/);
       if(accessTokenFromURL && expirationTimeFromURL){
         accessToken = accessTokenFromURL[1];
         expiresIn = expirationTimeFromURL[1];
         window.setTimeout(() => accessToken = '', expiresIn * 1000);
         window.history.pushState('Access Token', null, '/');
         return accessToken;
       } else {
         const accessUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectURI}`;
         window.location = accessUrl;
    }}
   return accessToken;
 },

 search(term) {
  const newAccessToken = this.getAccessToken();
  return fetch(`https://api.spotify.com/v1/search?type=track&q=${term}`, {
        headers: {
          Authorization: `Bearer ${newAccessToken}`
        }
      }).then(
      response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Request failed!');},
        networkError => console.log(networkError.message)).then(
      jsonResponse => {
        if(jsonResponse.tracks){
          return jsonResponse.tracks.items.map(track => ({
            id: track.id,
            name: track.name,
            artist: track.artists[0].name,
            album: track.album.name,
            uri: track.uri
          }))
       } else {
         return [];
       }
       });
  },

  savePlayList(playListName, trackURIs){
    if (!playListName || !trackURIs.length) {
      return;
    }
    const newAccessToken = this.getAccessToken();
    let userId;
    let playListId;
    const header = {
       Authorization: `Bearer ${newAccessToken}`
     };

    return fetch('https://api.spotify.com/v1/me', {
      headers: header
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Error - User ID Obtain Failed!');
    },
    networkError => console.log(networkError.message)).then(jsonResponse => {
        userId = jsonResponse.id;
    }).then(() => {
      return fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, {
        method: 'POST',
        headers: header,
        body: JSON.stringify({name: playListName})
      })}).then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Error - Playlist ID Obtain Failed!');
      },
      networkError => console.log(networkError.message)).then(jsonResponse => {
          playListId = jsonResponse.id;
      }).then(() => {
        return fetch(`https://api.spotify.com/v1/users/${userId}/playlists/${playListId}/tracks`, {
          method: 'POST',
          headers: header,
          body: JSON.stringify({uris: trackURIs})
        })}).then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Request failed!');
        },
        networkError => console.log(networkError.message)).then(jsonResponse => {
          console.log(jsonResponse);
        });
  }
};
export default Spotify;
/*
let accessToken;
let expiresIn;

const Spotify = {
  getAccessToken(){
    if (!accessToken) {
      let url = window.location.href;
      const accessTokenFromURL = url.match(/access_token=([^&]*)/);
      const expirationTimeFromURL = url.match(/expires_in=([^&]*)/);
       if(accessTokenFromURL && expirationTimeFromURL){
         accessToken = accessTokenFromURL[1];
         expiresIn = expirationTimeFromURL[1];
         window.setTimeout(() => accessToken = '', expiresIn * 1000);
         window.history.pushState('Access Token', null, '/');
         return accessToken;
       } else {
         const accessUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectURI}`;
         window.location = accessUrl;
    }}
   return accessToken;
 },

 search(term) {
  const newAccessToken = this.getAccessToken();
  return fetch(`https://api.spotify.com/v1/search?type=track&q=${term}`, {
        headers: {
          Authorization: `Bearer ${newAccessToken}`
        }
      }).then(
      response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Request failed!');},
        networkError => console.log(networkError.message)).then(
      jsonResponse => {
        if(jsonResponse.tracks){
          return jsonResponse.tracks.items.map(track => ({
            id: track.id,
            name: track.name,
            artist: track.artists[0].name,
            album: track.album.name,
            uri: track.uri
          }))
       } else {
         return [];
       }
       });
  },

  savePlayList(playListName, trackURIs){
    if (!playListName || !trackURIs.length) {
      return;
    }
    const newAccessToken = this.getAccessToken();
    let userId;
    let playListId;
    const header = {
       Authorization: `Bearer ${newAccessToken}`
     };

    return fetch('https://api.spotify.com/v1/me', {
      headers: header
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Error - User ID Obtain Failed!');
    },
    networkError => console.log(networkError.message)).then(jsonResponse => {
        userId = jsonResponse.id;
    }).then(() => {
      return fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, {
        method: 'POST',
        headers: header,
        body: JSON.stringify({name: playListName})
      })}).then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Error - Playlist ID Obtain Failed!');
      },
      networkError => console.log(networkError.message)).then(jsonResponse => {
          playListId = jsonResponse.id;
      }).then(() => {
        return fetch(`https://api.spotify.com/v1/users/${userId}/playlists/${playListId}/tracks`, {
          method: 'POST',
          headers: header,
          body: JSON.stringify({uris: trackURIs})
        })}).then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Request failed!');
        },
        networkError => console.log(networkError.message)).then(jsonResponse => {
          console.log(jsonResponse);
        });
  }
};

export default Spotify;
*
/*
let accessToken = '';
const clientID = 'bfd13971f3354e1998b1ccb292f54023';
const redirectURI = 'http://slh-jammming.surge.sh';

const Spotify = {

  getAccessToken() {
    if(accessToken) return accessToken;

    let token = window.location.href.match(/access_token=([^&]*)/);
    let expiresIn = window.location.href.match(/expires_in=([^&]*)/);    

    if (token && expiresIn) {
      accessToken = token[1];
      const expiration = Number(expiresIn[1]);

      window.setTimeout(() => accessToken = '', expiration * 1000);
      window.history.pushState('Access Token', null, '/');

      return accessToken;
    } else {
      window.location = `https://accounts.spotify.com/authorize?client_id=${clientID}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectURI}`;
    }    
  },

  async search(term) {
    const accessToken = Spotify.getAccessToken();
    const headers = { Authorization: `Bearer ${accessToken}` };
    
    let response = await fetch(`https://api.spotify.com/v1/search?type=track&q=${term}`, { headers: headers });
    let jsonResponse = await response.json();
      
    if(jsonResponse.tracks) {   
      return jsonResponse.tracks.items.map(track => ({
        id: track.id,
        name: track.name,
        artist: track.artists[0].name,
        album: track.album.name,
        uri: track.uri
      }));
    }    
  },

  async savePlaylist(playlistName, trackURIs) {
    if(!playlistName || !trackURIs.length) return;

    const accessToken = Spotify.getAccessToken();
    const headers = { Authorization: `Bearer ${accessToken}` };
    let userID = '';

    //Requesting user ID
    let response = await fetch('https://api.spotify.com/v1/me', { headers: headers });
    let jsonResponse = await response.json();
    
    userID = jsonResponse.id;

    //Creating new Playlist
    response = await fetch(`https://api.spotify.com/v1/users/${userID}/playlists`, {
      headers: { 
        Authorization: `Bearer ${accessToken}`, 
        'Content-Type': 'application/json' 
      }, 
      method: 'POST',
      body: JSON.stringify({name: playlistName})
    });
    jsonResponse = await response.json();

    let playlistID = jsonResponse.id;

    //Adding tracks to Playlist
    response = await fetch(`https://api.spotify.com/v1/users/${userID}/playlists/${playlistID}/tracks`, {
      headers: { 
        Authorization: `Bearer ${accessToken}`, 
        'Content-Type': 'application/json' 
      }, 
      method: 'POST',
      body: JSON.stringify({'uris': trackURIs})
    });
    jsonResponse = await response.json();
  }
}

export default Spotify;



// WEBPACK FOOTER //
// ./src/util/Spotify.js
/*
)
.then(jsonResponse => {
        userId = jsonResponse.id;
      })
      .then(() => {
        return fetch(`https://api.spotify.com/v1/users/${userId}/playlists`, {
          method: 'POST',
          headers: header,
          body: JSON.stringify({ name: playListName })
        });
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
      //  throw new Error('Error - Playlist ID Obtain Failed!');
      })
      .then(jsonResponse => {
        playListId = jsonResponse.id;
      })
      .then(() => {
        return fetch(`https://api.spotify.com/v1/users/${userId}/playlists/${playListId}/tracks`, {
          method: 'POST',
          headers: header,
          body: JSON.stringify({ uris: trackURIs })
        });
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Request failed!');
      })
      .then(jsonResponse => {
        console.log(jsonResponse);
      });
  }
}
  export default Spotify;
*/


// WEBPACK FOOTER //
// ./src/util/Spotify.js